import { Col, Form, Layout, Row } from "antd";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import moment from "moment";

import "../../index.css";
import "./monitor.css";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import SearchForm from "./search-form";
import SMPPUsageStatus from "./sms";
import SMPPQueueStatus from "./worker";

const { Content } = Layout;
Moment.globalLocal = false;

class SmppMonitor extends Component {
  state = {
    showMetric: false,

    memberId: 0,
    startDate: "",
    endDate: "",
    country: "",
  };

  componentWillMount() {
    this.props.fetchMenuAction("user-management", "smpp-customers-monitoring");
  }

  componentDidMount() {
    let IstartDate = moment().subtract(1, "M").format("YYYY-MM-DD");
    let IendDate = moment().format("YYYY-MM-DD");

    this.setState({
      startDate: IstartDate,
      endDate: IendDate,
    });
  }

  handleFilter = (form) => {
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      let startDate = "";
      let endDate = "";
      let memberId = 0;
      let country = "";

      if (values["range_date"]) {
        startDate = values["range_date"][0].format("YYYY-MM-DD");
        endDate = values["range_date"][1].format("YYYY-MM-DD");
      }

      if (values["member_id"]) {
        memberId = values["member_id"];
      }

      if (values["country"]) {
        country = values["country"];
      }

      this.setState({
        startDate,
        endDate,
        memberId,
        country,
      });
    });
  };

  onClickShowMetric = () => {
    this.setState({
      showMetric: !this.state.showMetric,
    });
  };

  render() {
    return (
      <Layout className="my-layout smpp-monitor">
        <Content
          style={{
            padding: 24,
            margin: "16px 0",
            minHeight: 300,
          }}
        >
          <Row className="component">
            <Col
              style={{
                padding: "12px",
              }}
              span={24}
            >
              <SearchForm
                style={{ width: "100%" }}
                fn={(form) => this.handleFilter(form)}
                onClickShowMetric={this.onClickShowMetric}
                showMetric={this.state.showMetric}
                form={this.props.form}
              />
            </Col>
          </Row>

          {this.state.showMetric ? (
            <SMPPQueueStatus />
          ) : (
            <SMPPUsageStatus
              memberId={this.state.memberId}
              country={this.state.country}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
            />
          )}
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

const MainForm = Form.create({ name: "search-frm" })(SmppMonitor);

export default connect(null, mapDispatchToProps)(MainForm);



// WEBPACK FOOTER //
// ./src/containers/SmppMonitor/index.js